import { ArrowPathIcon } from '@heroicons/react/20/solid'

export const Loading: React.FC = () => {
  return (
    <div className="flex items-center justify-center p-6">
      <ArrowPathIcon className="h-6 w-6 animate-spin" />
    </div>
  )
}
